module.exports = __webpack_public_path__ + "static/media/sp48.67e7bc9f.JPG";